import { Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { useSelector } from "react-redux";
import Error from "./Error";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	listItem: {
		padding: theme.spacing(1, 0),
	},
	total: {
		fontWeight: 700,
	},
	title: {
		marginTop: theme.spacing(2),
	},
}));

export default function Review() {
	const state = useSelector((state) => state);
	const classes = useStyles();

	return (
		<div className={classes.root}>
			{state.order.order.isFailed && <Error />}

			<Typography variant="h6" gutterBottom>
				Order summary
			</Typography>
			<Divider fullWidth />
			<List disablePadding width="100%">
				{state.order.order.items.map((product) => (
					<ListItem className={classes.listItem} key={product.sku}>
						<ListItemText primary={product.title} secondary={product.style} />
						<ListItemText primary="Quantity" secondary={product.quantity} />
						<Typography variant="body2">
							{product.currencyId +
								"" +
								new Intl.NumberFormat().format(product.price)}
						</Typography>
					</ListItem>
				))}
				<ListItem className={classes.listItem}>
					<ListItemText primary="Total" />
					<Typography variant="subtitle1" className={classes.total}>
						{state.order.order.currencyId +
							"" +
							Intl.NumberFormat().format(state.order.order.totalCost)}
					</Typography>
				</ListItem>
			</List>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<Typography variant="h6" gutterBottom className={classes.title}>
						Shipping
					</Typography>
					<Typography gutterBottom>
						{state.order.order.shippingInfo.length > 0
							? state.order.order.shippingInfo[0].firstName +
							  " " +
							  state.order.order.shippingInfo[0].lastName
							: ""}
					</Typography>
					<Typography gutterBottom>
						{state.order.order.shippingInfo.length > 0
							? state.order.order.shippingInfo[0].address1
							: ""}
					</Typography>
					<Typography gutterBottom>
						{state.order.order.shippingInfo.length > 0
							? state.order.order.shippingInfo[0].address2
							: ""}
					</Typography>
				</Grid>
				<Grid item container direction="column" xs={12} sm={6}>
					<Typography variant="h6" gutterBottom className={classes.title}>
						Payment details
					</Typography>
					<Grid container>
						{state.order.order.paymentInfo.length > 0
							? state.order.order.paymentInfo.map((payment) => {
									let paymentType = "";
									let paymentDetails = "";
									if (payment.card.cardNumber) {
										paymentType = "Card";
										paymentDetails = ``;
									}
									if (payment.cash.amountPaid) {
										paymentType = "Cash";
										paymentDetails = (
											<ul>
												<li>
													amount=
													{new Intl.NumberFormat().format(
														payment.cash.amountPaid
													)}
												</li>
												<li>status={payment.cash.status}</li>
												<li> statusDate={payment.cash.statusDate} </li>
											</ul>
										);
									}
									if (payment.mobileMoney.mobileNumber) {
										paymentType = "MobileMoney";
										paymentDetails = ``;
									}
									return (
										<React.Fragment key={payment._id}>
											<Grid item xs={6}>
												<Typography gutterBottom>{paymentType}</Typography>
											</Grid>
											<Grid item xs={6}>
												<Typography gutterBottom>{paymentDetails}</Typography>
											</Grid>
										</React.Fragment>
									);
							  })
							: ""}
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
}
